import React from 'react';
import { Navigate } from 'react-router-dom';
import ComercialUserManagement from '@crm/components/GRH/ComercialUserManagement';
import { useCognitoAuth } from '@crm/contexts/CognitoAuthContext';
import { getCccApiBase, getMainApiBase } from '../config';
import { canManageCccUsers } from '../utils/cccUserManagement';
import '../styles/cccUsers.css';

const CccUsersPage: React.FC = () => {
  const { user } = useCognitoAuth();
  const allowed = canManageCccUsers(user as Record<string, unknown> | undefined);

  if (!allowed) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="ccc-users-adapt">
      <ComercialUserManagement
        departmentLabel="CCC"
        heroSubtitle="Gerir e acompanhar a equipa CCC da Wondertrade"
        className="ccc-user-management"
        teamOptions={['CCC']}
        forcedTeam="CCC"
        apiBaseUrl={getCccApiBase()}
        usersListPath="/api/ccc/users"
        createUserPath="/api/ccc/users"
        updateUserPath={(id) => `/api/ccc/users/${id}`}
        usersListKeys={['users', 'comercial_users', 'data']}
        defaultDepartment="CCC"
        showCreateButton
        resendInvitationPath={(id) => `/api/ccc/users/${id}/resend-invitation`}
        updateEmailPath={(id) => `/api/ccc/users/${id}/update-email`}
        enableManagerSensitiveActions
        deleteUserPath={(id) => `/api/ccc/users/${id}`}
        suspendUserPath={(id) => `/api/ccc/users/${id}/suspend-cognito-access`}
        resourceBaseUrl={getMainApiBase()}
      />
    </div>
  );
};

export default CccUsersPage;
